// Maps /auth/epic/callback's real `epic_error=<CODE>` values (router.py, exceptions
// raised from state_service.consume_state and EpicClient.exchange_code_for_token) to
// patient-facing text. The backend sends a machine code only, never a human message —
// any code not listed here (a future addition, or one from a path this list missed)
// falls back to GENERIC rather than showing a raw code to the patient.
const EPIC_ERROR_MESSAGES: Record<string, string> = {
  MISSING_PARAMS: "The connection to your hospital was interrupted before it finished. Please try again.",
  INVALID_STATE: "This connection request is no longer valid. Please start over.",
  STATE_ALREADY_USED: "This connection request was already completed. Please start over if you still need to connect.",
  STATE_EXPIRED: "This connection request took too long and expired. Please try again.",
  EPIC_TOKEN_REQUEST_FAILED: "We couldn't reach your hospital's system. Please try again in a moment.",
  EPIC_TOKEN_EXCHANGE_FAILED: "Your hospital declined the connection request. Please try again.",
  EPIC_NO_PATIENT_CONTEXT: "Your hospital didn't confirm which patient record to share. Please try again.",
  EPIC_ACCESS_DENIED: "You didn't allow access at your hospital's sign-in, so nothing was connected. You can try again any time.",
  EPIC_AUTHORIZE_FAILED: "Your hospital's sign-in couldn't start the connection. Please try again later.",
};

const GENERIC_MESSAGE = "Something went wrong while connecting to your hospital. Please try again.";

export function describeEpicError(code: string | null): string {
  if (!code) return GENERIC_MESSAGE;
  return EPIC_ERROR_MESSAGES[code] ?? GENERIC_MESSAGE;
}
